<template>
  <div class="app_container_small">
    <div class="logo_wrapper">
      <img
        :src="require('@/assets/images/global/logo-full.svg')"
        style="height: 40px"
      />
    </div>
    <router-view></router-view>
  </div>
  <center><p class="body_copy_s">Peaki Pty Ltd</p></center>
</template>

<style scoped>
.app_container_small {
  max-width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: var(--border-radius);
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.logo_wrapper {
  width: fit-content;
  margin: 0 auto;
}
</style>
